// extracted by mini-css-extract-plugin
export default {"ModalSuccessfully":"ModalSuccessfully_ModalSuccessfully__EWj5j","container":"ModalSuccessfully_container__QynlL"};